import ClientDetailTabWorkedHour from '@/components/client/workedhour/DetailTabWorkedHour.vue'

const workedHourRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaHorasTrabalhadas`,
        path: `${basePath}/detalhe/:id/horas_trabalhadas`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            tabs
        },
        component: ClientDetailTabWorkedHour
    }
}

export default workedHourRouter
